import React, { useEffect, useState } from 'react';
import './LightstoneProgressBar.css';

/**
 * Time-based bar for the ~90s retrieve. Pass `startedAt` so every surface
 * (modal + stacked pill) stays on the same clock after remount.
 */
export function retrieveProgressPct(startedAt) {
    if (!startedAt) return 8;
    const s = Math.max(0, (Date.now() - Number(startedAt)) / 1000);
    return Math.min(92, 8 + 84 * (1 - Math.exp(-s / 38)));
}

export default function LightstoneProgressBar({
    active,
    startedAt = null,
    label = 'Retrieving details…',
    tone = 'light',
}) {
    const [pct, setPct] = useState(() => retrieveProgressPct(startedAt || (active ? Date.now() : 0)));
    useEffect(() => {
        if (!active) {
            setPct(8);
            return undefined;
        }
        const origin = Number(startedAt) || Date.now();
        const tick = () => setPct(retrieveProgressPct(origin));
        tick();
        const id = setInterval(tick, 200);
        return () => clearInterval(id);
    }, [active, startedAt]);
    if (!active) return null;
    const now = Math.round(pct);
    return (
        <div className={`ls-progress ls-progress--${tone}`} role="status" aria-live="polite">
            {label ? <div className="ls-progress__label">{label}</div> : null}
            <div
                className="ls-progress__track"
                role="progressbar"
                aria-valuemin={0}
                aria-valuemax={100}
                aria-valuenow={now}
                aria-label={label}
            >
                <div className="ls-progress__bar" style={{ width: `${pct}%` }} />
            </div>
        </div>
    );
}
